import { useContentProtection } from '../hooks/useContentProtection';

/** Invisible component — enables text/image copy protection on public routes. */
export const ContentProtector = () => {
  useContentProtection();
  return null;
};
